import * as React from "react";

import { ErrorBoundary } from "@/shared/components/ErrorBoundary";

import { DatasetList } from "./DatasetList";
import { DatasetListError, DatasetListLoading } from "./DatasetListFallbacks";

interface DatasetViewProps {
  activeDatasetId: string | null;
  orgId: string;
  onDatasetSelect: (datasetId: string) => void;
  getSelectedCountForDataset: (datasetId: string) => number;
  activeDatasetIds?: string[];
}

export function DatasetView(props: DatasetViewProps) {
  return (
    <ErrorBoundary fallback={({ error }) => <DatasetListError error={error} />}>
      <React.Suspense fallback={<DatasetListLoading />}>
        <DatasetList {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
}
